import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import TmAuthSignUpForbiddenError from '@/core/error/transport/auth/TmAuthSignUpForbiddenError'

export const registrationPhoneConfirmCodeUserDeniedErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.registrationPhoneConfirmCode,
  subCodes: ['registration.user_denied'],
  klass: TmAuthSignUpForbiddenError,
}
